import { AreaSearchResult } from '@alltrails/search/types/algoliaResultTypes';
import { useParkProfilePhoto } from '@alltrails/explore-service/hooks/useParkProfilePhoto';
import Image from '@alltrails/core/components/Image';
import { FormattedMessage } from 'react-intl';
import PaddingAwarePopup from '../PaddingAwarePopup/PaddingAwarePopup';
import { getPOIPopupOffset } from '../POI/POIResults/getPOIPopupOffset';
import styles from './ParkPopup.module.scss';

type ParkPopupProps = {
  coordinates?: [number, number];
  park: AreaSearchResult;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const ParkPopup = ({ park, coordinates, onMouseEnter, onMouseLeave }: ParkPopupProps) => {
  const { _geoloc, name, location_label, trails_count, type_label } = park;
  const profilePhotoUrl = useParkProfilePhoto({ parkId: park.ID, width: 160, height: 180 });

  return (
    <PaddingAwarePopup
      closeButton={false}
      closeOnClick={false}
      focusAfterOpen={false}
      latitude={coordinates?.[1] ?? _geoloc!.lat}
      longitude={coordinates?.[0] ?? _geoloc!.lng}
      maxWidth="327"
      offset={getPOIPopupOffset(true)}
    >
      <div className={styles.container} onMouseEnter={() => onMouseEnter?.()} onMouseLeave={onMouseLeave}>
        <div className={styles.imageContainer}>
          <Image alt={name} className={styles.image} fill src={profilePhotoUrl} handleLoadingState />
        </div>
        <div className={styles.info}>
          <div className={styles.name}>{name}</div>
          <div className={styles.area}>{location_label}</div>
          <div className={styles.details}>
            <FormattedMessage defaultMessage="{trailCount, plural, one {# trail} other {# trails}}" values={{ trailCount: trails_count }} /> •{' '}
            {type_label}
          </div>
        </div>
      </div>
    </PaddingAwarePopup>
  );
};

export default ParkPopup;
